<template>
	<div id="main-contents">
		<h3>404 Not Found !</h3>
		<p>
			お探しのページが見つかりませんでした。<br>
			URLが正しいかをご確認頂くか、管理者「Nande」までtwitterなりでお問い合わせください。
		</p>
	</div>
</template>

<script>
export default {

}
</script>

<style scoped>
	#main-contents {
		padding: 16px;
		margin-top: 8px;
	}

</style>